import {
	performIssuePutRequest,
	performIssueDeleteRequest,
} from '@atlassian/jira-issue-reliability-fetch/src/index.tsx';
import type { UserPreferences } from '@atlassian/jira-issue-shared-types/src/common/types/user-preferences-type.tsx';
import type { Value } from './types.tsx';

export const saveUserPreferenceValue = async (userPreferenceKey: UserPreferences, value: Value) =>
	performIssuePutRequest(
		`/rest/api/2/mypreferences?key=${userPreferenceKey}`,
		{
			body: value,
		},
		'user-preferences-services/src/utils',
	);

export const removeUserPreferenceValue = async (userPreferenceKey: UserPreferences) =>
	performIssueDeleteRequest(
		`/rest/api/2/mypreferences?key=${userPreferenceKey}`,
		undefined,
		'user-preferences-services/src/utils',
	);
